import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { USER_URLS } from '../../api/AdminUrls';
import { useSiteContext } from '../../contexts/SiteProvider';

import { showAlertAutoClose } from '../../services/notifyService';
import { role_get_select } from '../../services/site/SelectBoxServices';
import { post } from '../../services/smartApiService';

import { SdsFormElementProps } from 'soft_digi/dist/sdforms/SdsFromInterFace';

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}


const schema = Yup.object({
  emailid: Yup.string().email("Invalid email format").required("Email ID is required"),
  mobile_no: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  ename: Yup.string().min(3, "Name must be at least 3 characters").required("Name is required"),
  epassword: Yup.string().when("ID", {
    is: (id: any) => !id, // Required only for new users
    then: (schema) => schema.required("Password is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  role: Yup.array().min(1, "At least one role must be selected").required("Role is required"),
});

const UsersForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });

  const { closeModal } = useSiteContext();
  const [allRole, setAllRole] = useState([]);


 
  useEffect(() => {   
   
    role_get_select((data:any) => setAllRole(data));
  }, []);
 

  const onSubmit = (data: any) => {
    let url = USER_URLS.INSERT;
    if (data.ID !== undefined) {
      data["id"] = data.ID;
      url = USER_URLS.UPDATE;
    }

    const subscription = post(url, data).subscribe(() => {
      loadTableData();
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
    });

    return () => {
      subscription.unsubscribe();
    };
  };

  const formElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 4,
      name: "emailid",
      element: {
        label: "Email ID",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "mobile_no",
      element: {
        label: "Mobile No.",
        isRequired: true,
        inputType: "BORDER_LABEL",
        type: "number",
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "ename",
      element: {
        label: "Name",
        inputType: "BORDER_LABEL",
        isRequired: true,
      },
    },
    {
      type: "PASSWORD",
      width: 4,
      name: "epassword",
      element: {
        label: "Password",
        isRequired: !dataIn.ID,
        placeHolder: "Password",
        inputType: "BORDER_LABEL",
        disabled: !!dataIn.ID,
      },
    },
    {
      type: "SELECT_BOX",
      width: 4,
      name: "role",
      element: {
        label: "Role",
        inputType: "BORDER_LABEL",
        options: allRole,
        isMulti: true,
      },
    },
    {
      type: "LABEL",
      width: 8,
      name: "label",
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-efl-input">
      <SdsForm elements={formElements} errors={errors} control={control} />
    </div>
  );
};

export default UsersForm;
